/**
 * 从文件路径中提取文件名
 * @param {string} filePath - 文件路径
 * @returns {string} - 提取的文件名或占位符
 */
export const getFileName = (filePath) => {
    if (!filePath) return '—'

    // 按下划线分割路径
    const parts = filePath.split('_')

    // 如果有至少三个部分，返回从第三个部分到最后的所有部分
    if (parts.length >= 3) {
        return parts.slice(3).join('_')
    }

    // 如果格式不符合预期，返回原始文件路径
    return filePath
}

/**
 * 获取状态的文本描述
 * @param {number} status - 状态码
 * @returns {string} - 状态的文本描述
 */
export const getStatusText = (status) => {
    switch (status) {
        case 0:
            return '已支付'
        case 1:
            return '查询中'
        case 2:
            return '查询中'
        case 3:
            return '已完成'
        case 4:
            return '重试中'
        case 5:
            return '失败'
        default:
            return '未知'
    }
}

/**
 * 获取状态对应的类型（用于样式）
 * @param {number} status - 状态码
 * @returns {string} - 状态类型
 */
export const getStatusType = (status) => {
    switch (status) {
        case 0:
            return 'info'
        case 1:
            return 'warning'
        case 2:
            return 'warning'
        case 3:
            return 'success'
        case 4:
            return 'danger'
        default:
            return 'info'
    }
}
